module.exports = __webpack_public_path__ + "static/media/Head shot _1631215072176.28d5a5e5.jpeg";